/** @jsxImportSource @emotion/react */
import classNames from 'classnames';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import UDNavLink, { type IUDNavLinkProps } from 'ud-ui/components/link/nav-link';

interface IAllTournamentButtonProps extends Omit<IUDNavLinkProps, 'to'> {}

function AllTournamentButton(props: IAllTournamentButtonProps) {
  return (
    <UDNavLink
      {...props}
      to={Pages.TOURNEYS.INDEX}
      variant={props.variant ?? 'secondary'}
      className={classNames('text caption-1 fw-700 ml-2', props.className)}
      style={{ transition: 'color 0.2s ease', ...props.style }}
    >
      Все турниры
    </UDNavLink>
  );
}

export default AllTournamentButton;
